import { Skeleton, Stack } from "@mui/material";
import ContentWrapper from "../components/ContentWrapper";

export default function ConfigurationsSkeleton() {
	return (
		<ContentWrapper>
			<Skeleton height="24px" />
			<Skeleton height="24px" />
			<Stack gap="0.625rem">
				<Skeleton height="24px" />
				<Skeleton variant="rectangular" height="92px" />
				<Skeleton variant="rectangular" height="92px" />
				<Skeleton variant="rectangular" height="92px" />
				<Skeleton variant="rectangular" height="92px" />
			</Stack>
		</ContentWrapper>
	);
}
